import React, { useEffect, useRef } from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box } from "@mui/material";

const useStyles = (theme, mt) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },
    width: "100%",
    alignItems: "center",
  },
  child: {
    width: { xs: "286px", md: "800px", lg: "1100px", xl: "1400px" },
    mt,
    display: "flex",
    flexDirection: { xs: "column" },
    boxShadow: { xs: "0 4px 100px 0 rgba(199, 206, 211, 0.25)" },
    borderRadius: { xs: "47px" },
    height: { xs: "198px", md: "168px" },
    alignItems: { xs: "center" },
    justifyContent: { xs: "center" },
    bgcolor: theme.palette.white.main,
    mb: { xs: "45px", md: "inherit" },
  },
  text: {
    fontSize: { xs: "25px", xl: "27px" },
    lineHeight: { xs: "35px", md: "30px", lg: "34px", xl: "50px" },
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.regular,
    width: { xs: "255px", md: "607px", lg: "924px", xl: "1205px" },
    textAlign: { xs: "center" },
    fontWeight: "bold",
  },
});

const MainText = ({ text, mt, scroll }) => {
  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current && focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement && scroll) {
      focusOnElement();
    }
  }, [scroll]);

  const theme = useTheme();
  const classes = useStyles(theme, mt);

  return (
    <Box sx={classes.container} ref={focusElement}>
      <Box sx={classes.child}>
        <Typography sx={classes.text}>{text}</Typography>
      </Box>
    </Box>
  );
};

export default MainText;
